export default __webpack_public_path__ + "static/media/interpol.098ca7ea.jpg";